import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import SettingRow from 'bundles/personalization-settings/components/SettingRow';

import _t from 'i18n!nls/personalization-settings';

export type SettingItemProps = {
  label: string;
  /**
   * The learner's explicit value for this field. When absent (no explicit value
   * set), the row renders a "Not set" placeholder.
   */
  value?: string | null;
};

/**
 * A single read-only Learner Object setting: the label in the left column and
 * the current value on the right. Presentational only — the label and value are
 * supplied by the parent. A field with no explicit value renders a "Not set"
 * placeholder.
 */
const SettingItem = ({ label, value }: SettingItemProps) => (
  <SettingRow label={label}>
    <Typography2 component="p" variant="bodyPrimary" color="supportText">
      {value || _t('Not set')}
    </Typography2>
  </SettingRow>
);

export default SettingItem;
